/**
 * Хелпер для сохранения последнего ipoteka_id в localStorage.
 *
 * Нужен только во время разработки/тестирования: позволяет ходить
 * по 4 экранам через Stepper даже на welcome (где id ещё нет).
 *
 * Когда продукт зарелижен — можно убрать или оставить как UX-удобство
 * («продолжить заполнение»).
 */

const KEY = 'ipoteka.lastTestId';

export function getLastIpotekaId(): string {
    try {
        return localStorage.getItem(KEY) || '';
    } catch {
        return '';
    }
}

export function setLastIpotekaId(id: string | number | null | undefined): void {
    if (id === null || id === undefined || id === '') return;
    try {
        localStorage.setItem(KEY, String(id));
    } catch {
        // ignore — если localStorage недоступен (приватный режим, квота), просто пропускаем
    }
}
